import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'

import { Typography, Paper } from '@material-ui/core'
import Box from '@material-ui/core/Box'

const styles = theme => ({
  root: {
  },
  muted: {
      color: '#888'
  },
  calendarSectionDetail:{
    textAlign: 'center',
    width:'50px',
    height: 'auto'
    // [theme.breakpoints.down('xs')]:{
    //   width: '27.5%'
    // }
  },
  trainingMonthYear:{
    borderTop: '1px solid #999',
    backgroundColor: '#999',
    color:'white',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    fontSize: '12px',
    paddingBottom: '2px'
  },
  trainingDays:{
    fontSize: '10px'
  },
  trainingDate:{
    lineHeight: '1',
    fontSize: '17px',
    paddingTop: theme.spacing(0.5),
  },
  topDate:{
    borderTop: '1px solid #999',
    borderLeft: '1px solid #999',
    borderRight: '1px solid #999',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    backgroundColor:'white'
  },
});

const DateCard = ({ classes, theme, item, time }) => {
    
  let rootStyle = {}

  return (
    <Box>
      <Box className={classes.calendarSectionDetail} mb={0.5} mr={0.5}>
        <Box className={classes.topDate}>
          <Typography variant='body1' className={classes.trainingDate}>
              { moment(item).format("DD") }
          </Typography>
          <Typography variant='body2' className={classes.trainingDays}>
          { moment(item).format("ddd") }
          </Typography>
        </Box>
        <Box className={classes.trainingMonthYear}>
            { moment(item).format("MMM 'YY") }
        </Box>
      </Box>
      {time &&
        <Typography variant='body2' className={classes.muted}>{ time || '-'}</Typography>
      }
    </Box>
  )
}

export default withStyles(styles, { withTheme: true })(DateCard)